import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom, PrimitiveAtom } from 'jotai';
import { ExperienceGPTAnswer, UnavailableExperienceData } from 'shared/models';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

type ExperienceAnswerStore = { [key: string]: Promise<ExperienceGPTAnswer | UnavailableExperienceData> | undefined };

const $ExperienceGPTAnswerStore: PrimitiveAtom<ExperienceAnswerStore> = atom<ExperienceAnswerStore>({});

export const $ExperienceGPTAnswer = safeAtomFamily((keyword: string) => {
  const a = atom(
    (get) => {
      const data = get($ExperienceGPTAnswerStore)[keyword];
      if (!data) {
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        return Unreachable(`no data for GPTAnswer: ${keyword}`);
      }
      return data;
    },
    (get, set, args: any) => {
      const old = get($ExperienceGPTAnswerStore);
      set($ExperienceGPTAnswerStore, { ...old, [keyword]: args });
    },
  );

  a.debugLabel = `$ExperienceGPTAnswer+${encodeURIComponent(keyword)}`;

  return a;
});
